import React from "react";

const SvgComponent = props => (
  <svg
    viewBox="10 10 21.39 20.23"
    height="5em"
    style={{ margin: "0 auto" }}
    display="block"
    color="#87465b"
    {...props}
  >
    <path
      d="M13.408 19.921h2.05l.994-2.236.931 5.777 2.671-8.51 1.305 10.373 1.304-8.013.994 1.988h4.224"
      fill="none"
      stroke="currentColor"
      strokeWidth={0.35}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SvgComponent;



// WEBPACK FOOTER //
// ./images/collectif.svg